import { api } from '@services';

import Invite, { IInvite, IInviteApiModel } from '@models/Invite.model';

const getInvite = async (id: string): Promise<IInvite> => {
  const { data: invite } = await api.get<IInviteApiModel>(`/invites/${id}`);

  return Invite.fromApiModel(invite);
};

export { getInvite };
